const path = (root: string, subLink: string) => {
  return `${root}${subLink}`;
};

const ROOT_AUTH = '/auth';
const ROOT_DASHBOARD = '/dashboard';
const ROOT_ACCOUNT = '/account';

//------------------------------------------------------
export const PATH_AUTH = {
  root: ROOT_AUTH,
  login: path(ROOT_AUTH, '/login'),
};

export const PATH_DASHBOARD = {
  root: ROOT_DASHBOARD,
  modules: path(ROOT_DASHBOARD, '/modules'),
  accounts: path(ROOT_DASHBOARD, '/accounts'),
  roles: path(ROOT_DASHBOARD, '/roles'),
  access: path(ROOT_DASHBOARD, '/access'),
  logs: path(ROOT_DASHBOARD, '/logs'),
  departments: path(ROOT_DASHBOARD, '/departments'),
};

export const PATH_ACCOUNT = {
  root: ROOT_ACCOUNT,
  password: path(ROOT_ACCOUNT, '/password'),
};
